import React from 'react';
import {
    BillingCommitment,
    useSamplesCatalog,
    getFormattedPrice,
} from '@landr/pricing';
import { Modal, Badge, Text, Image, Button, Flex, Box } from '@landr/maestro';
import { t, Trans } from '@lingui/macro';
import { CONFIG } from 'utils/config';
import { getReturnUrl } from 'helpers';
import { ModalProps } from 'modals/Modal.types';
import { Styled } from './SweetenerUpsellModal.styled';

export const SweetenerUpsellModalContent: React.FC = () => {
    const { data } = useSamplesCatalog();

    const plan = data?.plans?.find(
        ({ frequency }) => frequency === BillingCommitment.Yearly,
    );

    const price = getFormattedPrice({
        value: plan?.subscriptionPrice ?? 0,
        currency: data?.currency || {
            currencyCode: 'USD',
            currencySymbol: '$',
        },
    });

    const discountPercentage = 50;

    const discountPrice = getFormattedPrice({
        value: plan?.subscriptionPrice
            ? (plan?.subscriptionPrice * discountPercentage) / 100
            : 0,
        currency: data?.currency || {
            currencyCode: 'USD',
            currencySymbol: '$',
        },
    });

    const returnUrl = getReturnUrl();
    const couponCode = '50OFFSAMPLES';
    const purchaseUrl = `${CONFIG.VITE_PURCHASE_URL}/${plan?.code}/Yearly/${couponCode}?returnUrl=${returnUrl}`;

    return (
        <Box backgroundColor="#fff">
            <Modal.Header>
                <Flex
                    justifyContent="center"
                    alignItems="center"
                    pl="xxl"
                    width="100%"
                >
                    <Badge
                        variant="primary"
                        kind="subtle"
                        isRounded
                        content={t`HOT DEAL - ${discountPercentage}% OFF!`}
                    />
                </Flex>
            </Modal.Header>
            <Modal.Content>
                <Modal.Section p="0">
                    <Styled.ContentContainer>
                        <Styled.HeaderContainer>
                            <Text size="xl" fontWeight="bold">
                                <Trans>Get 6 months for free!</Trans>
                            </Text>
                        </Styled.HeaderContainer>
                        <Box>
                            <Image
                                loading="lazy"
                                src={'/assets/modals/sweetener-packs.png'}
                                width={280}
                                height={180}
                                alt={t`Sweetener packs`}
                            />
                        </Box>
                        <Styled.TextContainer>
                            <Text size="md" color="neutral.500">
                                <Trans>
                                    Pay {discountPrice} upfront instead of{' '}
                                    {price}
                                </Trans>
                            </Text>
                            <Text size="md" color="neutral.500" mt="xxs">
                                <Trans>
                                    Available for a limited time only.
                                </Trans>
                            </Text>
                        </Styled.TextContainer>
                    </Styled.ContentContainer>
                </Modal.Section>
            </Modal.Content>
            <Modal.Footer>
                <Flex justifyContent={'center'} width="100%">
                    <Button
                        as={'a'}
                        variant="primary"
                        href={purchaseUrl}
                        mb="xxs"
                        isRounded
                    >
                        <Trans>Get deal</Trans>
                    </Button>
                </Flex>
            </Modal.Footer>
        </Box>
    );
};

export const SweetenerUpsellModal: React.FC<ModalProps> = ({
    handleClose,
    isOpen,
}) => {
    const handleCloseSweetenerModal = () => {
        handleClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleCloseSweetenerModal}
            maxWidth="480px"
        >
            <SweetenerUpsellModalContent />
        </Modal>
    );
};

export default SweetenerUpsellModal;
